import { render } from "./ComboTipo.vue?vue&type=template&id=7dcd284b&ts=true"
import script from "./ComboTipo.vue?vue&type=script&lang=ts"
export * from "./ComboTipo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__